export default {
  metadata: {
    name: 'JDSStepperDot',
    description:
      'Steppers help break a complex task into a series of manageable steps and guides useres through each step of their progress.',
    usage:
      'Steppers are used to support new and improve existing processes such as checkout and account application journeys.'
  },
  hierarchy: {
    'step-icon-container': [
      'count-jds-text',
      'icon',
      'complete-icon',
      'dot-container'
    ]
  },
  base: {
    'step-icon-container': {
      'background-color': '{s_0}',
      'border-width': '{s_1}',
      'border-color': '{s_2}',
      'min-height': '{s_3}',
      'min-width': '{s_4}',
      'justify-content': '{s_5}',
      'align-items': '{s_6}',
      'border-radius': '{s_7}',
      show: true
    },
    icon: {
      hidden: true,
      color: '{s_8}',
      size: '{s_9}'
    },
    'complete-icon': {
      hidden: true,
      value: 'ic_confirm',
      color: '{s_10}',
      size: '{s_11}'
    },
    'dot-container': {
      hidden: true,
      'background-color': '{s_12}',
      width: '{s_13}',
      height: '{s_14}',
      'border-radius': '{s_15}',
      show: true
    },
    'count-jds-text': {
      'font-family': '{text_167}',
      color: '{text_50}',
      'font-size': '{text_166}',
      'line-height': '{text_168}',
      'letter-spacing': '{text_169}',
      'font-weight': '{text_170}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    state: {
      active: {
        'step-icon-container': {
          'background-color': '{s_16}',
          'border-color': '{s_17}'
        },
        icon: {
          color: '{s_18}'
        },
        'dot-container': {
          'background-color': '{s_19}'
        },
        'count-jds-text': {
          color: '{text_46}'
        }
      },
      complete: {
        'step-icon-container': {
          'background-color': '{s_20}',
          'border-color': '{s_21}'
        },
        'complete-icon': {
          hidden: false
        },
        'count-jds-text': {
          hidden: true
        }
      },
      disabled: {
        'step-icon-container': {
          disabled: true,
          opacity: '{s_26}'
        }
      }
    },
    itemsType: {
      icon: {
        'dot-container': {
          hidden: true
        },
        'step-icon-container': {
          height: '{s_22}',
          width: '{s_23}'
        },
        'count-jds-text': {
          hidden: true
        }
      },
      dot: {
        icon: {
          hidden: true
        },
        'dot-container': {
          hidden: false
        },
        'count-jds-text': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      complete: {
        icon: {
          icon: {
            hidden: true
          }
        },
        dot: {
          'dot-container': {
            hidden: true
          }
        }
      },
      active: {
        icon: {
          icon: {
            hidden: false
          }
        }
      },
      inactive: {
        icon: {
          icon: {
            hidden: false
          }
        }
      }
    },
    {
      warning: {
        active: {
          icon: {
            hidden: false,
            value: 'ic_exclamation',
            color: '{s_24}'
          },
          'dot-container': {
            hidden: true
          },
          'count-jds-text': {
            hidden: true
          }
        },
        complete: {
          icon: {
            hidden: false,
            value: 'ic_exclamation',
            color: '{s_25}'
          },
          'complete-icon': {
            hidden: true
          },
          'dot-container': {
            hidden: true
          },
          'count-jds-text': {
            hidden: true
          }
        }
      }
    }
  ],
  combination_config: [
    ['state', 'itemsType'],
    ['activeState', 'state']
  ],
  api: {
    config: {
      state: {
        values: ['inactive', 'active', 'complete', 'disabled']
      },
      itemsType: {
        values: ['numbered', 'icon', 'dot'],
        doc_description: 'Represents the type of Stepper indication.'
      },
      activeState: {
        values: ['normal', 'warning'],
        doc_description:
          'Devs will set this to show the warning states for active index only.'
      }
    },
    data: {
      icon: {
        value: {
          type: 'icon',
          name: 'icon',
          function: true,
          doc_description:
            'Optional icon. Only shows if parent stepper type is icon.'
        }
      },
      'count-jds-text': {
        value: {
          type: 'string',
          name: 'index'
        }
      }
    }
  }
};
